import { render, staticRenderFns } from "./ViewVersionSwitcher.vue?vue&type=template&id=0979baba&scoped=true"
import script from "./ViewVersionSwitcher.vue?vue&type=script&lang=ts"
export * from "./ViewVersionSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./ViewVersionSwitcher.vue?vue&type=style&index=0&id=0979baba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979baba",
  null
  
)

export default component.exports